var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFairPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20.1617 11 20.3235 11.0352 20.4711 11.102L27.091 13.9109C27.8645 14.2379 28.441 15.0008 28.4375 15.9219C28.4199 19.4094 26.9856 25.7902 20.9281 28.6906C20.341 28.9719 19.659 28.9719 19.0719 28.6906C13.0145 25.7902 11.5801 19.4094 11.5625 15.9219C11.559 15.0008 12.1356 14.2379 12.909 13.9109L19.5324 11.102C19.6766 11.0352 19.8383 11 20 11ZM20 13.3484V26.6375C24.8516 24.2891 26.1559 19.0895 26.1875 15.9711L20 13.3484Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFairPlay);
export default __webpack_public_path__ + "static/media/ic_fair_play.273f05f0164f6d96fadcf8f0ab2eec54.svg";
export { ForwardRef as ReactComponent };